import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";

/**
 * Dedicated Apollo client for fay GraphQL subscriptions.
 *
 * The Apollo gateway composes Query + Mutation but cannot execute Subscription
 * types (it's @apollo/gateway, which has no subscription transport), so the
 * browser talks to the fay service directly for `workflowEvents`. This client is
 * passed explicitly to useSubscription; the host app's own gateway client stays
 * untouched and queries/mutations still go through the gateway.
 *
 * Transport: subscriptions run over a long-lived HTTP POST with incremental
 * `multipart/mixed` delivery — NOT a WebSocket. Strawberry serves this on its
 * subscriptions router's POST handler when the request sends the multipart
 * accept header; Apollo Client reads multipart subscription bodies natively, so
 * `useWorkflowEventsSubscription` is unchanged — only the transport differs.
 * Plain HTTP needs no upgrade handshake, so it routes through the CDN/Traefik
 * far more simply than `wss://` did.
 *
 * Same-origin relative path: the Traefik IngressRoute maps
 * `/service/fay/graphql/subscriptions` to fay's mount, and `credentials:
 * "same-origin"` lets the auth cookie ride the request (fay arena-authorizes
 * the workflow id server-side). There is no app-specific configuration here —
 * no host, no environment variable, no cache policy — so each app's bundle gets
 * its own module-scope singleton and needs to inject nothing.
 */
const FAY_SUBSCRIPTIONS_PATH = "/service/fay/graphql/subscriptions";

const faySubscriptionLink = new HttpLink({
  uri: FAY_SUBSCRIPTIONS_PATH,
  // Ask the server for incremental multipart delivery; this is what flips
  // Strawberry from a single JSON response to a streamed subscription.
  headers: { accept: "multipart/mixed;subscriptionSpec=1.0,application/json" },
  credentials: "same-origin",
});

export const faySubscriptionClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: faySubscriptionLink,
});
